import { useTheme } from '@emotion/react'

import {
  FoxMonoLogo,
  UnivisionMonoLogo,
  CrossFitMonoLogo,
  ArduinoMonoLogo,
  AbInBevMonoLogo,
} from '@segment/matcha/components/CompanyLogos/CompanyMono'
import {
  FoxLogo,
  UnivisionLogo,
  CrossFitLogo,
  ArduinoLogo,
  AbInBevLogo,
} from '@segment/matcha/components/CompanyLogos/Company'

const testimonialData = () => {
  const theme = useTheme()
  return [
    {
      company: `fox`,
      logoName: `Fox`,
      logoActive: <FoxLogo />,
      logo: <FoxMonoLogo color={theme.palette.twilio.gray[70]} />,
      text: `“One of the many things Twilio Segment helps Fox with is saving data team resources by speeding the connection of new data sources. In one instance, it took Segment 15 minutes to connect a new data source that would typically require a two-week sprint. In Daryl’s words: “This is still one of the main reasons that we use Twilio Segment today. And if this is all that Twilio Segment did for us, I'd still be incredibly happy.”`,
      position: `Executive Vice President of Technology`,
      extendedRate: `$1.2M`,
      extendedText: `Saved annually from streamlined data maintenance`,
      extendedLink: `/customers/fox/`,
    },
    {
      company: `univision`,
      logoName: `Univision`,
      logoActive: <UnivisionLogo />,
      logo: <UnivisionMonoLogo color={theme.palette.twilio.gray[70]} />,
      text: `“Regardless of scale, Segment provides you the tools and platform to move quickly and efficiently. We couldn’t have done this any other way.”`,
      name: `Jay Iyer`,
      position: `Vice President of Data Engineering`,
      extendedRate: `3 months`,
      extendedText: `to launch new streaming service, saving the efforts of 8 engineers`,
      extendedLink: `/customers/univision/`,
    },
    {
      company: `crossfit`,
      logoName: `CrossFit`,
      logoActive: <CrossFitLogo />,
      logo: <CrossFitMonoLogo color={theme.palette.twilio.gray[70]} />,
      text: `“Now, our our data and teams are cohesive and connected, we can make data driven decisions and reach our customers effectively.”`,
      name: `Jay Meyering`,
      position: `Senior Software Development Manager`,
      extendedRate: `30%`,
      extendedText: `Greater efficiency with engineering resources`,
      extendedLink: `/customers/crossfit/`,
    },
    {
      company: `arduino`,
      logoName: `Arduino`,
      logoActive: <ArduinoLogo />,
      logo: <ArduinoMonoLogo color={theme.palette.twilio.gray[70]} />,
      text: (
        <>
          <b>70% greater efficiency with engineering resources with new data sources added 90% faster</b> <br />
          <br />
          “Arduino is a complex ecosystem with dozens of websites across millions of users. Thanks to Segment we can
          control all our web properties through a single script, significantly simplifying data management across our
          vast ecosystem.”
        </>
      ),
      name: `Claudio Scafesi`,
      position: `Data Analytics Team Lead`,
      extendedRate: `90%`,
      extendedText: `Time saved adding new data sources`,
      extendedLink: `/customers/arduino/`,
    },
    {
      company: `ab-in-bev`,
      logoName: `AbInBev`,
      logoActive: <AbInBevLogo />,
      logo: <AbInBevMonoLogo color={theme.palette.twilio.gray[70]} />,
      text: `Using Twilio Segment for data collection and unification enables AB InBev to customize experiences on their BEES B2B platform, offering retailers tools for better inventory management. This boosts growth, digital transformation, and loyalty with global retailers.`,
      extendedRate: `3 Billion`,
      extendedText: `Data points collected per month across sources`,
      extendedLink: `/customers/ab-inbev`,
    },
  ]
}

export { testimonialData }
